import React from 'react';
import { Provider, connect } from 'react-redux';
import Login from './layout/Login';
import LockScreen from './layout/LockScreen';
import MainHeader from './layout/MainHeader';
import MainSideBar from './layout/MainSideBar';
import MainMenu from './layout/MainMenu';
import MainUserMenu from './layout/MainUserMenu';
import MainContextMenu from './layout/MainContextMenu';
import MainReleaseInfoMenu from './layout/MainReleaseInfoMenu';
import MainContent from './layout/MainContent';
import MainFooter from './layout/MainFooter';
import { loginUser, logoutUser, loadContext } from '../actions';
import { ConnectedRouter } from 'connected-react-router';
import { history } from "src/store";
import {setContent} from "../actions";
import classNames from "classnames";
import Pace from "./layout/Pace";
import Favico from "react-favico-js";
import { SnackbarProvider } from 'notistack';
import {isChristmas} from "../utils/other";
import GlobalSearch from "./layout/GlobalSearch";

class Page extends React.Component {
    constructor(props) {
        super(props);
        props.loginUser();
        props.loadContext();
        this.state = {};
        this.state.locked = false;
        this.doSomething = this.doSomething.bind(this);

        window.onclick = this.doSomething;
        window.onmousemove = this.doSomething;
        window.onkeypress = this.doSomething;
        window.onscroll = this.doSomething;
    }

    doSomething() {
        /*const user = this.props.user;
        if(this.lockscreen) {
            clearTimeout(this.lockscreen);
        }
        if(user && user.hasPermission(window.envBooqadmin.loginPrivilege || "admin")) {
            this.lockscreen = setTimeout(function () {
                this.props.logoutUser(() => {
                    this.setState({locked: true, user: user});
                });
            }.bind(this), 10 * 60000);
        }*/
    }

    render() {
        /*if(this.state.lockscreen) {
            clearTimeout(this.state.lockscreen);
        }*/
        const isItChristmas = isChristmas(true);
        const user = this.props.user;
        if(this.state.locked) {
            const lockeduser = this.state.user || this.props.user;
            return <div className="hold-transition lockscreen"><LockScreen user={lockeduser} onUnlock={() => { this.setState({locked: false}); this.doSomething(); }}/></div>
        }
        const favico = this.props.favico;
        favico.counter = Object.entries(this.props.editors).filter((entry) => entry[1].dirty).length;
        if(user && user.hasPermission(window.envBooqadmin.loginPrivilege || "admin")) {
            this.doSomething();
            /*this.state.lockscreen = setTimeout(function () {
                this.props.logoutUser(() => {this.setState({locked: true, user});});
            }.bind(this), 10 * 60000);*/

            // add action to all snackbars
            const onClickDismiss = key => () => {
                this.notistackRef && this.notistackRef.closeSnackbar(key);
            }

            return <SnackbarProvider
                ref={(notistackRef) => this.notistackRef = notistackRef}
                maxSnack={3}
                classes={{root: "toast"}}
                action={(key) => (
                    <button className="btn btn-default btn-xs" onClick={onClickDismiss(key)}>
                        &times;
                    </button>
                )}
                domRoot={document.getElementById("toasts")}
            >
                <div
                    className={classNames("", {
                        "sidebar-mini sidebar-collapse": this.props.config.sidebar.sidebarCollapsed,
                        "fixed sidebar-open": !this.props.config.sidebar.sidebarCollapsed,
                        "christmas": isItChristmas,
                    })}
                >
                    <Pace/>
                    <Favico {...favico} />
                    <MainHeader>
                        <MainReleaseInfoMenu/>
                        <MainContextMenu/>
                        <MainUserMenu/>
                    </MainHeader>
                    <MainSideBar>
                        <MainMenu/>
                    </MainSideBar>
                    <MainContent/>
                    <MainFooter/>
                    {/*<GlobalSearch />*/}
                </div>
            </SnackbarProvider>;
        } else {
            return <div className="hold-transition login-page"><Login /></div>
        }
    }
}

const App = connect((state) => ({
    user: state.app.user,
    config: state.app.template,
    favico: state.app.favico,
    editors: state.editors
}), {
    loadContext,
    loginUser,
    logoutUser,
    setContent
})(Page);

export default class Application extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            online: navigator.onLine !== false
        };
    }

    updateIndicator = () => {
        this.setState({
            online: navigator.onLine !== false
        });
    };

    componentDidMount() {
        window.addEventListener('online',  this.updateIndicator);
        window.addEventListener('offline', this.updateIndicator);
    }

    componentWillUnmount() {
        window.removeEventListener('online',  this.updateIndicator);
        window.removeEventListener('offline', this.updateIndicator);
    }

    render() {
        return (
            <Provider store={this.props.store}>
                <ConnectedRouter history={history}>
                    {!this.state.online && <div className="offline-indicator">Nincs internet!</div>}
                    <div id="toasts"/>
                    <App />
                    <div id="portal"/>
                    <div id="fullscreen"/>
                </ConnectedRouter>
            </Provider>
        );
    }
}